var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.dataSources),function(dataSource){return _c('details-datasource',{key:dataSource,attrs:{"instance":_vm.instance,"data-source":dataSource}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }